import "style/style.scss";

import {domReady} from "@/utils/domReady";
import Index from "./../js";

domReady(() => {
    // tslint:disable-next-line
    new Index();
    // @ts-ignore
    // import 'js/main';
});
